<ng-template [sbmodal]="'sbPreviewListModal'">
  <sb-custom-modal [templateId]="'sbPreviewListModal'">
    <div slot="body">
      <sb-preview-list [attributeType]="'CLIENT'" [isInModalContext]="'sbPreviewListModal'"></sb-preview-list>
    </div>
  </sb-custom-modal>
</ng-template>

<sb-card>
  <div card-header>
    {{ 'nav.network.devices.details.playbackSchedule' |translate }}
    @if (sharedPlaybackSchedules()?.length > 1) {
      {{ currentSchedule }}
    }
  </div>
  <div card-header-more class="d-flex">
    <div class="d-flex align-items-center">
      @if (sharedPlaybackSchedules()?.length > 1) {

        <sb-icon (click)="e?.prev()" class="mx-1 cursor-pointer blue" icon="arrowLeftAlt">
        </sb-icon>
        {{ currentSchedule }} {{ 'lang.globals.of' | translate }} {{ sharedPlaybackSchedules()?.length }}
        <sb-icon (click)="e?.next()" class="mx-1 cursor-pointer blue" icon="arrowRightAlt">
        </sb-icon>
      }
    </div>
  </div>
  <div card-body>

    <ngb-carousel #e (slide)="currentSchedule = $event.current" [activeId]="currentSchedule" [interval]="-1" [keyboard]="false"
                  [showNavigationArrows]="false" [showNavigationIndicators]="false" [wrap]="true">
      @for (schedule of sharedPlaybackSchedules(); track $index; let i = $index) {
        <ng-template id="{{i+1}}" ngbSlide>
          <div class="tw-grid tw-grid-cols-4 tw-gap-3">
            <div>
              <h3>
                Info
              </h3>
              <div class="tw-flex tw-flex-row">
                <div class="tw-flex tw-flex-col tw-justify-start">
                  <!--
                  <div class="m-3 d-flex" *ngIf="sharedPlaylist?.playlist?.schedule">
                    <sb-icon class="mr-2" icon="schedules"></sb-icon>
                    {{ 'lang.schedules.schedule'|translate }}:
                    {{ sharedPlaylist?.playlist?.schedule?.name }}
                  </div>
                  -->
                  <div class="tw-m-3 tw-flex" [class.tw-pointer-events-none]="isInDeviceContext()">
                    <a (click)="showScreensModal(schedule?.screens)">
                      <sb-icon class="mr-2" icon="screen"></sb-icon>
                      {{ 'lang.globals.screens'|translate }}:
                      {{ schedule?.screens?.length }}
                    </a>
                  </div>
                  <div class="tw-m-3 tw-flex">
                    <a (click)="showDateTimeRanges(schedule?.ranges)">
                      <sb-icon class="tw-mr-2" icon="calendar"></sb-icon>
                      {{ 'lang.globals.timeRanges'|translate }}:
                      {{ schedule?.ranges?.length }}
                    </a>
                  </div>
                </div>
              </div>
              <div class="tw-flex tw-mt-2 tw-flex-col tw-justify-start">
                @for (range of schedule?.ranges; track $index) {
                  <div
                    class="d-flex my-1 mx-3 border-dashed-bottom"
                    container="body"
                    [ngbTooltip]="util.calculateTimespanBetweenDates(range?.from, range?.till)"
                  >
                    {{ util.dateToDateTimeString(range?.from?.value) }}  -  {{ util.dateToDateTimeString(range?.till?.value) }}
                  </div>
                }
              </div>
            </div>
            <div class="tw-col-span-3">
              @let playbackSchedule = schedule.playbackSchedule;
              @if (playbackSchedule) {
                <sb-card>
                  <div card-header class="">{{ playbackSchedule?.name }}
                  </div>
                  <div card-header-more class="">
                    <sb-comp-filter-overview class="tw-flex" hideClass="d-xxl" [timeCull]="playbackSchedule?.timeCull"
                                             [geoCull]="playbackSchedule?.geoCull"
                                             [stateSpaceCull]="playbackSchedule?.stateSpaceCull"
                                             [playerCull]="playbackSchedule?.playerCull">
                    </sb-comp-filter-overview>
                  </div>


                  <div card-body>
                    <div class="tw-overflow-auto">
                      <table class="table">
                        <thead>
                        <tr>
                          <th>#</th>
                          <th>{{ 'lang.scheduleDetails.slotType' | translate }}</th>
                          <th>Name</th>
                          <th>{{ 'lang.scheduleDetails.contentCull' | translate }}</th>
                          <th>{{ 'lang.scheduleDetails.clientCull' | translate }}</th>
                          <th>{{ 'lang.globals.deals' | translate }}</th>
                          <th>{{ 'lang.globals.fallback' | translate }}</th>
                          <th>{{ 'lang.globals.share' | translate }}</th>
                          <th>{{ 'lang.globals.minDuration' | translate }}</th>
                          <th>{{ 'lang.globals.duration' | translate }}</th>
                          <th>{{ 'lang.globals.percentage' | translate }}</th>
                        </tr>
                        </thead>
                        <tbody>
                          @for (slot of playbackSchedule?.slots; track slot.orderNum) {
                            <tr>
                              <td class="col-sm">
                                {{ slot?.orderNum + 1 }}
                              </td>
                              <td class="col-md">
                                <div class="card mr-1 mb-0"
                                     style="height: 100%; width: 100%; display: inline-block; overflow: hidden; color:white"
                                     [ngClass]="util.getSlotType(slot, 'Class')" (click)="showClients(slot?.clientCull?.id)">
                  <span [innerHTML]="util.getSlotType(slot, 'Name') | truncate : 25"
                        class="d-flex align-items-center justify-content-center px-4 py-3 "></span>
                                </div>
                              </td>
                              <td class="col-md">
                                @if (slot?.name) {
                                  <span [innerHTML]="slot?.name | truncate: 15"></span>
                                } @else {
                                  -
                                }
                              </td>
                              <td class="col-md">
                                {{ slot.contentCull?.name ?? '-' }}
                              </td>
                              <td class="col-md">
                                {{ slot?.clientCull?.name ?? '-' }}
                              </td>
                              <td class="col-md">
                                @for (deal of slot?.deals; track deal.id) {
                                  <div> {{ deal?.name && deal?.identifier ? (deal?.name + '(' + deal?.identifier + ')') : (deal?.name ?? deal?.identifier ?? '-') }}</div>
                                } @empty {
                                  -
                                }
                              </td>
                              <td class="col-md">
                                @if (slot?.fallbackOrderNum?.length > 0) {
                                  <span class="mr-1" [innerHTML]="getOrderNums(slot).join(',')|truncate: 12"></span>
                                } @else {
                                  -
                                }
                              </td>
                              <td class="col-md">
                                @if (slot?.share) {

                                  {{ slot?.share }}&nbsp;&#x25;
                                } @else {
                                  -
                                }
                              </td>
                              <td class="col-md">
                                {{ slot?.minDuration ?? '-' }}
                                @if (slot?.minDuration || slot?.minDuration === 0) {
                                  &nbsp;s
                                }
                              </td>
                              <td class="col-md">
                                {{ slot?.duration ?? '-' }}
                                @if (slot?.duration || slot?.duration === 0) {
                                  &nbsp;s
                                }
                              </td>
                              <td class="col-md">
                                {{ slot?.percentage ?? '-' }}
                                @if (slot?.percentage || slot?.percentage === 0) {
                                  &nbsp;&#x25;
                                }
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </sb-card>
              } @else {
                {{ 'lang.globals.noData' | translate }}
              }

            </div>
          </div>
        </ng-template>
      } @empty {
        {{ 'lang.globals.noData' | translate }}
      }
    </ngb-carousel>
  </div>
</sb-card>
